var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.3,15.65A15.65,15.65,0,1,0,13.2,31.11V20.174H9.231V15.65H13.2V12.2c0-3.922,2.336-6.089,5.911-6.089a24.066,24.066,0,0,1,3.5.306V10.27H20.646a2.262,2.262,0,0,0-2.55,2.444V15.65h4.34l-.694,4.524H18.1V31.11A15.654,15.654,0,0,0,31.3,15.65Z","fill":"#ebebed"}));
}

Facebook.defaultProps = {"focusable":"false","width":"31.3","height":"31.11","viewBox":"0 0 31.3 31.11"};

module.exports = Facebook;

Facebook.default = Facebook;
